import {getDomainName} from '../../../utils/url'
import {cookieSecuritySettings} from '../../utils/cookies/cookieSecuritySettings'
import {isBrowser} from '../../utils/environment'

const maxAge = 30 // 30 days
const name = 'sapiLabel'

/**
 * Configuration for the sapiLabel cookie.
 */
export const sapiLabelCookieConfig = {
  name,
  options: {
    maxAge,
    domain: !isBrowser ? '' : getDomainName(window.location.hostname),
    ...cookieSecuritySettings(true)
  }
}
